module.exports = __webpack_public_path__ + "img/sj.7d33f13d.png";